import { UPCOMING } from 'constants/GameStatuses';
import { ReactNode } from 'react';
import LocalizedDate from 'components/LocalizedDate';

export default function GameStatusText({
  game,
  dateFormat = 'h:mm A',
  children
}: {
  game: {
    statusId: number;
    date: string;
  };
  dateFormat?: string;
  children: ReactNode;
}) {
  if (game.statusId === UPCOMING) {
    return <LocalizedDate date={game.date} format={dateFormat} />;
  }

  return <>{children}</>;
}
